import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import TR from './../../Trans';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ThemeToggleButton from '../items/ThemeToggleButton';
import { GlobalStyles } from "@mui/material";
import { useLocalStorage } from '../../services/useLocalStorage';
import muvikaAttrs from './../../attrs';
import backgroundImage from "../../assets/people-group-4-square.jpg";
import Stack from '@mui/material/Stack';
import { ReactComponent as MuvikaLogo } from './../../assets/logo-horiz.svg';
import { ReactComponent as MuvikaLogoInv } from './../../assets/logo-horiz-inv.svg';
import { ReactComponent as MuvikaLogoProInv } from './../../assets/logo-horiz-pro-inv.svg';
import CssBaseline from '@mui/material/CssBaseline';
import { Capacitor } from '@capacitor/core';
import Typography from '@mui/material/Typography';
import Error from './../items/Error';
import Message from './../items/Message';
import Container from '@mui/material/Container';
import sessionStore from './../../stores/session';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: "var(--back-color)"
    }
  },
});

function WaitingAccount() {

  useEffect(() => {
    document.documentElement.style.fontSize = "16px";
    window.dispatchEvent(new Event('refitbuttons'));
    window.dispatchEvent(new Event('resize'));
  }, []);

  const [theme, setTheme] = useLocalStorage(muvikaAttrs.service + "-theme", "dark");

  const renderLogo = () => {
    if (!theme || theme === "dark") {
      return <MuvikaLogo className="muvika-logo-svg" />;
    } else {
      return <MuvikaLogoInv className="muvika-logo-svg" />;
    }
  };

  const isSessionOpen = sessionStore((state) => state.isSessionOpen);
  const isLoggedIn = sessionStore((state) => state.isLoggedIn);
  const renderContainer = () => {
    if (isSessionOpen && isLoggedIn) {
      return <Container className="muvika-entry-container" component="main" maxWidth="xs">
        <CssBaseline />
        <Error />
        <Message />
        <Box
          className="muvika-entry-box"
        >
          <p>
            <a href="#/">{renderLogo()}</a>
          </p>
          <Box sx={{ margin: 2 }}>
            <Typography component="p" variant="p">
              {TR.cm_continue_after_subscription}
            </Typography>
          </Box>
          <Stack direction="row" spacing={6} justifyContent="center">
            <Button href="/" variant="text" color="success">Ok</Button>
          </Stack>
          <ThemeToggleButton />
        </Box>
      </Container>;
    }
  };

  const overflowStyleIos = `
  html {
    overflow-y:scroll !important;
  }
  
  body {
    overflow-y:scroll !important;
  }
  
  main {
    overflow-y:scroll !important;
  }
`;

  const overflowStyle = `
  html {
    overflow-y:auto !important;
  }
  
  body {
    overflow-y:auto !important;
  }
  
  main {
    overflow-y:auto !important;
  }
`;

  const renderOverflowStyle = () => {
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      return <style>
        {overflowStyleIos}
      </style>;
    } else {
      return <style>
        {overflowStyle}
      </style>;
    }
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <GlobalStyles
        styles={{
          body: {
            margin: 0,
            minHeight: "100vh",
            minWidth: "100vw",
            backgroundImage: `url(${backgroundImage}) !important`,
            backgroundRepeat: "no-repeat !important",
            backgroundSize: "cover !important",
            backgroundPosition: "center !important",
          },
        }}
      />
      {renderOverflowStyle()}
      {renderContainer()}
    </ThemeProvider>
  );
}

export default WaitingAccount;